import { Element } from 'html-react-parser';
import { parseDocument } from 'htmlparser2';

export type ArticleHtmlSections = {
  intro: Element[];
  sections: Element[][];
};

const ELEMENT_NODE_TYPES = ['tag', 'script', 'style'];

export const isElementNode = (node: { type: string }): node is Element => ELEMENT_NODE_TYPES.includes(node.type);

const isSectionHeading = (element: Element) => element.name === 'h2';

export const splitArticleHtml = (html?: string | null): ArticleHtmlSections => {
  const elements = parseDocument(html || '').children.filter(isElementNode);
  const firstHeadingIndex = elements.findIndex(isSectionHeading);
  const intro = firstHeadingIndex === -1 ? elements : elements.slice(0, firstHeadingIndex);

  const sections = elements.slice(intro.length).reduce<Element[][]>((result, element) => (
    isSectionHeading(element)
      ? [...result, [element]]
      : [...result.slice(0, -1), [...result[result.length - 1], element]]
  ), []);

  return { intro, sections };
};
